import { useTheme } from '@emotion/react';

const PatientPortalPageStyle = () => {
  const theme = useTheme();

  return {
    arrow_button: {
      marginTop: '-32px',
      marginLeft: '-12px',
    },
    arrow_icon: {
      fontSize: '36px',
      color: theme.palette.primary.main,
    },
    container: {
      padding: '40px',
      border: '1px solid #d9d9d9',
      borderRadius: '10px',
      marginBottom: '32px',
    },
    user_info_container: {
      display: 'flex',
      flexDirection: { xs: 'column', lg: 'row' },
      alignItems: 'center',
      justifyContent: 'start',
      gap: { xs: '32px', sm: '10px', lg: '20px' },
    },
    avatar_container: {
      flexBasis: '20%',
      textAlign: 'center',
    },
    user_name: {
      fontWeight: '500',
      fontSize: '24px',
      marginTop: '32px',
      textTransform: 'capitalize',
    },
    user_avatar: {
      width: '190px',
      height: '190px',
      margin: 'auto',
    },
    user_details: {
      flexBasis: '80%',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      columnGap: '16px',
      rowGap: '8px',
    },
    user_info_box_extended: {
      padding: { xs: '4px 8px', sm: '12px 16px' },
      border: '1px solid #d9d9d9',
      borderRadius: '10px',
      flexBasis: { xs: '100%', sm: '98%' },
      display: 'flex'
    },
    user_info_box: {
      padding: { xs: '4px 8px', sm: '12px 16px' },
      border: '1px solid #d9d9d9',
      borderRadius: '10px',
      flexBasis: { xs: '100%', sm: '48%' },
      display: 'flex'
    },
    user_info_value: {
      color: theme.palette.custom.black['50'],
      marginLeft: '8px',
      marginRight: '8px',
      direction: 'ltr'
    },
    user_encounter_container: {
      marginTop: '32px',
      border: '1px solid #d9d9d9',
      borderRadius: '10px',
      padding: '24px 32px',
    },
    sub_title: {
      fontWeight: '500',
      fontSize: '20px',
    },
    search_container: {
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      gap: '8px',
      margin: '24px 0',
    },
    search_by: {
      flexBasis: '30%',
    },
    search_filed: {
      flexBasis: '50%',
    },
    search_button: {
      flexBasis: '20%',
      padding: '6px',
      maxHeight: '40px',
    },
    not_found_message: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#686868',
      marginTop: '32px',
      gap: '8px',
    },
    analysis_page_button: {
      width: '150px',
      mt: '24px',
    },
    pagination: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '32px',
    },
    alertBox: {
      marginTop: '10px'
    },
    alertTitle: {
      marginRight: '10px'
    },
    searchByStateBox: {
      display: 'flex',
      flex: 1
    },
    searchByStateButtons: {
       margin: '0 10px'
    },
    loadEncounters: {
      display: 'flex', justifyContent: 'center'
    },
  };
};

export default PatientPortalPageStyle;
